import { get } from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import viewportBoundariesMixin from 'vue/mixins/viewport-boundaries';
import isMountedMixin from 'vue/mixins/is-mounted';


export default {
    mixins: [
        isMountedMixin,
        viewportBoundariesMixin,
    ],
    props: {
        position: {
            type: Number,
        },
    },
    computed: {
        ...mapGetters(['sections']),
        anchor() {
            return get(this, 'content.anchor');
        },
    },
    methods: {
        ...mapActions(['updateTitleSection', 'updateSection', 'removeSection', 'scrollToSection']),
        updateNav() {
            if (!this.isMounted) {
                return;
            }

            this.updateSection({
                section: {
                    position: this.position,
                    content: this.content,
                    boundaries: this.boundaries,
                },
            });
        },
    },
    watch: {
        content: {
            handler() {
                this.updateNav();
            },
            deep: true,
            immediate: true,
        },
        boundaries: {
            handler() {
                this.updateNav();
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        const { anchor } = this;

        if (anchor !== window.location.hash.substr(1)) {
            return;
        }

        this.scrollToSection({ anchor });
    },
    beforeDestroy() {
        this.removeSection({
            section: {
                position: this.position,
                content: this.content,
            },
        });
    },
};



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/mixins/section/index.js